export function anoIRPF(doc:{tipo?:string|null|undefined;descricao?:unknown;arquivo?:string|null|undefined}) : number|null {
 const texto = String(doc.descricao ?? '') + ' ' + (doc.arquivo ?? '');
 if (!/irpf|imposto.*renda|declara[cç][aã]o.*ajuste/i.test((doc.tipo??'')+' '+texto)) return null;
 const cal=texto.match(/ano[- ]?calend[aá]rio\s*[:/–-]?\s*(20\d{2})/i);
 if(cal) return Number(cal[1]);
 const exerc=texto.match(/exerc[ií]cio\s*[:/–-]?\s*(20\d{2})/i) ?? texto.match(/IRPF[ _-]*(20\d{2})/i);
 return exerc ? Number(exerc[1])-1 : null;
}
